import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import {RTLButton, RTLCol} from "../RTLKit";
import TextField from "../formFields/TextField";
import CheckBoxField from "../formFields/CheckBoxField";
import {Divider, Form, Row} from "antd";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import SelectField from "../formFields/SelectField";
import _ from 'lodash';
import {API_FETCH} from '../../services/FetchService';
import "./styles.css";

const mobileValidation = value =>
value && !/^(?:0|98|\+98|\+980|0098|098|00980)?(9\d{9})$/i.test(value) ?
'تلفن همراه را صحیح وارد کنید.' : undefined


class WizardFormFirstPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            createUser : false,
            chooseAddress : false,
            addressList : [],
            haveOrder:false,
            haveTicket:false,
            userticket:"",
        };
        this.__loadUserInfo = this.__loadUserInfo.bind(this)
    }

    componentDidMount() {
        this.props._reduxForm.getAreaList();
        if(this.props._reduxForm.match.params.mob){
            let mob = this.props._reduxForm.match.params.mob
            this.props._reduxForm.getUserList({mobile:mob});
            this.setState({
                mobile : mob
            });
        }
        if(this.props._reduxForm.match.params.userId){
            let userId = this.props._reduxForm.match.params.userId
            API_FETCH.get('order/v2/orders?customer_by='+userId)
            .then(list => {
                if(list.status === 201) {
                    for (const iterator of list.data.lists) {
                        if(iterator.current_status=='ORDER_CREATED' || iterator.current_status=='ORDER_ASSIGNED'){
                            this.setState({haveOrder:true})
                        }
                    }
                }
            }).catch(error => {
                console.log(error);
            });

            API_FETCH.get('user/'+userId)
            .then(list => {
                if(list.status === 200) {
                    if(list.data.userTicket!=null || list.data.userTicket!=undefined){
                        this.setState({haveTicket:true})
                        switch (list.data.userTicket.value) {
                            case 'WERE_CONTACTED':
                                return this.setState({userticket:'تماس گرفته شد.'+' - '+list.data.userTicket.note});
                            case 'THEY_CHANGE_THEMSELVES':
                                return this.setState({userticket:'خودشان تعویض می کنند.'+' - '+list.data.userTicket.note});
                            case 'THEY_DID_NOT_ANSWER':
                                return this.setState({userticket:'پاسخ ندادند.'+' - '+list.data.userTicket.note});
                            case 'IT_IS_OFF':
                                return this.setState({userticket:'خاموش بود.'+' - '+list.data.userTicket.note});
                            case 'BLOCK_LIST':
                                return this.setState({userticket:'بلاک لیست.'+' - '+list.data.userTicket.note});
                            case 'THEY_CALL_THEMSELVES':
                                return this.setState({userticket:'خودشان تماس میگیرند.'+' - '+list.data.userTicket.note});
                            case 'RELUCTANCE_TO_RECEIVE_SERVICE':
                                return this.setState({userticket:'عدم تمایل به دریافت سرویس.'+' - '+list.data.userTicket.note});
                            case 'FREE_VISIT':
                                return this.setState({userticket:'بازدید رایگان.'+' - '+list.data.userTicket.note});
                            case 'MISCELLANEOUE':
                                return this.setState({userticket:'متفرقه'+' - '+list.data.userTicket.note});
                            case 'CALL_BACK':
                                return this.setState({userticket:'تماس مجدد'+' - '+list.data.userTicket.note});
                        }
                    } else {
                        this.setState({haveTicket:false})
                        this.setState({userticket:null})
                    }
                }
            }).catch(error => {
                console.log(error);
            });

            this.setState({
                userId : userId
            });
        }
    }

    onChange(val){
        this.setState({
            createUser : val.target.checked
        });
        this.props._reduxForm.createdUser(val.target.checked)
    }

    __loadUserInfo(val){
        this.props._reduxForm.getUserList({mobile:val.target.value});
        if(this.props._reduxForm.userList){
            let userId = this.props._reduxForm.userList.lists[0]!==undefined?this.props._reduxForm.userList.lists[0]._id:'';

            API_FETCH
            .get('order/v2/orders?customer_by='+userId)
            .then(list => {
                if(list.status === 201) {
                    for (const iterator of list.data.lists) {
                        if(iterator.customer_by.mobile==val.target.value){
                            if(iterator.current_status=='ORDER_CREATED' || iterator.current_status=='ORDER_ASSIGNED'){
                                this.setState({haveOrder:true})
                            }
                        }
                    }
                }
            }).catch(error => {
                console.log(error);
            });

            API_FETCH.get('user/'+userId)
            .then(list => {
                if(list.status === 200) {
                    if(list.data.userTicket!=null || list.data.userTicket!=undefined){
                        this.setState({haveTicket:true})
                        switch (list.data.userTicket.value) {
                            case 'WERE_CONTACTED':
                                return this.setState({userticket:'تماس گرفته شد.'+' - '+list.data.userTicket.note});
                            case 'THEY_CHANGE_THEMSELVES':
                                return this.setState({userticket:'خودشان تعویض می کنند.'+' - '+list.data.userTicket.note});
                            case 'THEY_DID_NOT_ANSWER':
                                return this.setState({userticket:'پاسخ ندادند.'+' - '+list.data.userTicket.note});
                            case 'IT_IS_OFF':
                                return this.setState({userticket:'خاموش بود.'+' - '+list.data.userTicket.note});
                            case 'BLOCK_LIST':
                                return this.setState({userticket:'بلاک لیست.'+' - '+list.data.userTicket.note});
                            case 'THEY_CALL_THEMSELVES':
                                return this.setState({userticket:'خودشان تماس میگیرند.'+' - '+list.data.userTicket.note});
                            case 'RELUCTANCE_TO_RECEIVE_SERVICE':
                                return this.setState({userticket:'عدم تمایل به دریافت سرویس.'+' - '+list.data.userTicket.note});
                            case 'FREE_VISIT':
                                return this.setState({userticket:'بازدید رایگان.'+' - '+list.data.userTicket.note});
                            case 'MISCELLANEOUE':
                                return this.setState({userticket:'متفرقه'+' - '+list.data.userTicket.note});
                            case 'CALL_BACK':
                                return this.setState({userticket:'تماس مجدد'+' - '+list.data.userTicket.note});
                        }
                    } else {
                        this.setState({haveTicket:false})
                        this.setState({userticket:null})
                    }
                }
            }).catch(error => {
                console.log(error);
            });

            this.setState({
                userId : userId
            });
        }
    }

    __getAreaStateList() {
        let areaList = this.props._reduxForm.areaList;
        let dataSource = [];

        if (areaList) {
            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );
            }
        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    __getAddressList(list) {//this.props._reduxForm.userList.lists[0]
        let dataSource = [
            {label: 'آدرس جدید', value: 1, key: 1}
        ];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].text, value: list[i]._id, key: list[i]._id}
                );
            }
        }
        return dataSource;
    }

    __chooseAddress(val){
        if(val != 1) {
            var address = _.find(this.props._reduxForm.userList.lists[0].addresses, function (obj) {
                return obj._id === val;
            });
            this.setState({stateId: address.stateId, cityId: address.cityId,text:address.text,tag:address.tag})
        }else
            this.setState({stateId: '', cityId: '',tag:'',text:''})
        if(val === 1)
            this.setState({new_address : true, chooseAddress: false})
        else {
            this.setState({new_address: false, chooseAddress: true})
        }
    }

    render() {

        const {handleSubmit} = this.props;
        let _self = this;
        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();

        var cityList = [];

        /* ----- find selected city  -----*/
        if(this.props.initialValues && this.state.mode == 'edit') {
            this.state.stateId = this.props.initialValues.state._id
        }

        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Divider orientation="left">ایجاد سفارش</Divider>
                </Row>
                {
                    this.state.haveOrder==true?
                    <Row>
                        <p  style={{color: 'red',fontSize: '20px'}}>این کاربر سفارش تکمیل نشده دارد</p>
                    </Row>
                    :
                    null
                }
                {
                    this.state.haveTicket==true?
                    <Row>
                        <p  style={{color: 'green',fontSize: '15px'}}>برای این کاربر تیک تیکت ثبت شده است : {this.state.userticket}</p>
                    </Row>
                    :
                    null
                }
                
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle">
                        <Row gutter={16}>
                            <Field
                                min="0"
                                validate={mobileValidation}
                                name="mobile"
                                component={TextField}
                                type="number"
                                label="شماره همراه"
                                placeholder="شماره همراه"
                                maxLength={11}
                                required={true}
                                defaultValue={this.props._reduxForm.userList && this.props._reduxForm.userList.lists[0] ? this.props._reduxForm.userList.lists[0].mobile : ''}
                                onChange={(val) => this.__loadUserInfo(val)}
                            />
                            <Field
                                name="phone_number"
                                component={TextField}
                                type="text"
                                label="شماره تلفن"
                                placeholder="شماره تلفن"
                                defaultValue={this.props._reduxForm.userList && this.props._reduxForm.userList.lists[0] ? this.props._reduxForm.userList.lists[0].phone_number : ''}
                            />
                            <Field
                                name="name"
                                component={TextField}
                                type="text"
                                label="نام"
                                placeholder="نام"
                                defaultValue={this.props._reduxForm.userList && this.props._reduxForm.userList.lists[0] ? this.props._reduxForm.userList.lists[0].name : ''}
                            />
                            <Field
                                name="family"
                                component={TextField}
                                type="text"
                                label="نام خانوادگی"
                                placeholder="نام خانوادگی"
                                defaultValue={this.props._reduxForm.userList && this.props._reduxForm.userList.lists[0] ? this.props._reduxForm.userList.lists[0].family : ''}
                            />
                            {this.props._reduxForm.userList && this.props._reduxForm.userList.lists[0] && this.props._reduxForm.userList.lists[0].addresses.length > 0 ?
                                <Field
                                contentEditable={true}
                                    name="address"
                                    component={SelectField}
                                    type="text"
                                    label="آدرس ها"
                                    placeholder="آدرس"
                                    list={this.__getAddressList(this.props._reduxForm.userList.lists[0].addresses)}
                                    onChange={(val) => this.__chooseAddress(val)}
                                />
                                :
                                <div>
                                    <Field
                                        name="tag"
                                        component={TextField}
                                        type="text"
                                        label="برچسب"
                                        required={true}
                                        placeholder="برچسب به عنوان مثال خانه ، شرکت"
                                    />
                                    <Field
                                        name="new_address"
                                        component={TextField}
                                        type="text"
                                        label="آدرس"
                                        required={true}
                                        placeholder="آدرس"
                                    />
                                </div>
                            }
                            <Field
                                name="stateId"
                                component={SelectFieldForLoadState}
                                label="استان"
                                list={stateList}
                                onChangeVal={(stateId) => {
                                    _self.setState({stateId: stateId})
                                }}
                                defaultValue={this.state.stateId ? this.state.stateId : ''}
                            />
                            <Field
                                name="cityId"
                                component={SelectFieldForLoadCity}
                                label="شهر"
                                list={cityList}
                                defaultValue={this.state.cityId ? this.state.cityId : ''}
                            />
                            {/* <Field
                                name="tag"
                                component={TextField}
                                type="text"
                                label="برچسب"
                                placeholder="برچسب به عنوان مثال خانه ، شرکت"
                                defaultValue={this.state.tag ? this.state.tag : ''}
                            />
                            <Field
                                name="new_address"
                                component={TextField}
                                type="text"
                                label="آدرس"
                                placeholder="آدرس"
                                defaultValue={this.state.text ? this.state.text : ''}
                            /> */}
                            {this.state.new_address === true ?
                                <div>
                                    <Field
                                        name="tag"
                                        component={TextField}
                                        type="text"
                                        label="برچسب"
                                        placeholder="برچسب به عنوان مثال خانه ، شرکت"
                                    />
                                    <Field
                                        name="new_address"
                                        component={TextField}
                                        type="text"
                                        label="آدرس"
                                        placeholder="آدرس"
                                    />
                                </div>
                            :null}
                        </Row>
                        {/* <Field
                                name="description"
                                component={TextField}
                                type="text"
                                label="توضیحات"
                                placeholder="توضیحات"
                            /> */}
                        <Field
                            name="create_user"
                            component={TextField}
                            type="checkbox"
                            label="ایجاد سفارش"
                            onChange={this.onChange.bind(this)}
                            defaultValue={false}
                        />
                    </RTLCol>
                </Row>
                <Row>
                    <RTLButton type="primary" disabled = {this.state.createUser === false ? true : false} shape="round"
                               htmlType="submit" className="login-form-button">
                        ثبت و سفارش
                    </RTLButton>
                    <RTLButton disabled = {this.state.createUser === false ? false : true} type="default"  shape="round" htmlType="submit" className="backBtn">
                        ثبت کاربر
                    </RTLButton>
                </Row>
            </form>
        );
    }
};

export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(WizardFormFirstPage);
